<template>
    <i
        v-if="icon"
        class="hts-icons flex items-center flex-initial"
        :class="cClass"
        :style="colorStyle"
        v-bind="$attrs"
        @click="emits('click', $event)" />
    <hts-icon-svg
        v-else-if="svg"
        :name="svg"
        class="hts-icons flex items-center flex-initial"
        :class="cClass"
        :color="color"
        :stroke-color="strokeColor"
        :fill-color="fillColor"
        v-bind="$attrs"
        @click="emits('click', $event)" />
    <component
        :is="iconName"
        v-else-if="iconName"
        :color="color"
        :style="colorStyle"
        class="hts-icons flex items-center flex-initial"
        :class="cClass"
        v-bind="$attrs"
        @click="emits('click', $event)">
        <slot />
    </component>
</template>
<script setup lang="ts">
const sizes = ['v-mini', 'mini', 'small', 'default', 'large', 'xl', '2xl', '3xl']
const emits = defineEmits(['click'])
const props = defineProps({
  icon: String,
  svg: String,
  iconName: String,
  size: String,
  color: String,
  strokeColor: String,
  fillColor: String
})
const { icon, svg, iconName, size, color } = toRefs(props)
const cClass = computed(() => {
  let cls = ''
  if (iconClass.value) {
    cls += iconClass.value
  }
  if (sizeClass.value) {
    cls += ' ' + sizeClass.value
  }
  return cls
})
const sizeClass = computed(() => {
  if (!size?.value || !sizes.includes(size?.value)) {
    return null
  }
  return `hts-icons__size-${size.value}`
})
const iconClass = computed(() => {
  return icon?.value || ''
})
const colorStyle = computed(() => {
  return {
    color: color?.value
  }
})
</script>
